// extracted by mini-css-extract-plugin
module.exports = {"left":"Border_left__3mIFn","visible":"Border_visible__1U5ii","right":"Border_right__2_474"};